import { assertNever } from '@kofno/piper';
import { TPlainTextKey } from '../../../../../Translations';
import { LicenseAvailability } from './LicenseAlertsStore/Types';

// Only a license the organization can assign today is worth naming as a remedy;
// the rest would be a shopping list, not an action.
export const isAssignable = (status: LicenseAvailability): boolean => {
  switch (status) {
    case 'available':
    case 'not-yet-started':
      return true;
    case 'expired':
    case 'not-held':
      return false;
    default:
      return assertNever(status);
  }
};

// "Available" is the expected case, and saying so under every course is noise.
// The other three change what the admin can actually do.
export const isWorthLabelling = (status: LicenseAvailability): boolean => {
  switch (status) {
    case 'available':
      return false;
    case 'not-yet-started':
    case 'expired':
    case 'not-held':
      return true;
    default:
      return assertNever(status);
  }
};

export const statusLabel = (status: LicenseAvailability): TPlainTextKey => {
  switch (status) {
    case 'available':
      return 'Available';
    case 'not-yet-started':
      return 'Not yet started';
    case 'expired':
      return 'Expired';
    case 'not-held':
      return 'Not held';
    default:
      return assertNever(status);
  }
};

export const statusClassName = (status: LicenseAvailability): string => {
  switch (status) {
    case 'available':
      return 'text-accent';
    case 'not-yet-started':
      return 'text-primary';
    case 'expired':
    case 'not-held':
      return 'text-muted-foreground';
    default:
      return assertNever(status);
  }
};
